<!--
    Componente de login do sistema, que comporta cadastro e recuperação de senha.
-->
<template>
  <div class="cont">
    <toolbar-system></toolbar-system>
    <alertbar-system v-if="AlertbarShow != null" :alertbar="AlertbarShow"></alertbar-system>
    <v-container fluid fill-height>
      <v-layout v-show="recuperar == null && cadastroView == null" align-center justify-center class="animated fadeIn">
        <v-flex sm6 lg6 xl4>
          <v-avatar size="100" src="./img/logo/icon.png"></v-avatar>
          <v-card>
            <v-card-title>
                <h1>Login</h1>
            </v-card-title>
            <v-card-text>
                <v-form>
                  <v-text-field :error="this.usuario.login.length == 11 && validaCPF()" @keyup="validaCPF()" v-model="usuario.login" color="blue" mask="###.###.###-##" label="Login" prepend-icon="mdi mdi-account-card-details-outline"></v-text-field>
                  <v-text-field @keyup.enter="goLogin()" v-model="usuario.senha" color="blue" type="password" label="Senha" prepend-icon="mdi mdi-key-variant"></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 lg4>
                    <v-btn :loading="logando" :disabled="validaCPF()" class="blue darken-1 white--text" @click.stop="goLogin()" block large>
                      <v-icon left>mdi mdi-send</v-icon>
                      Logar
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-btn @click="cadastroView = !cadastroView" block large flat>
                      <v-icon left>mdi mdi-account-plus-outline</v-icon>
                      Cadastro
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-btn @click="recuperar = !recuperar" block large flat>
                      <v-icon left>mdi mdi-key-variant</v-icon>
                      Recuperar Senha
                    </v-btn>
                  </v-flex>

                  <!--v-flex sm6>
                    <v-img width="250" src="/img/lojas/google-play-badge.png"></v-img>
                  </v-flex>
                  <v-flex sm6>
                    <v-img class="imgAjust" width="200" src="/img/lojas/Download_on_the_App_Store_Badge_PTBR_RGB_blk_092917.svg"></v-img>
                  </v-flex-->

                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <!--FORM CADASTRO-->
      <v-layout v-show="cadastroView != null" align-center justify-center class="animated fadeIn">
        <v-flex sm4>
          <v-card>
            <v-btn @click="cadastroView = null" fab dark color="orange" class="backLogin">
              <v-icon dark>mdi mdi-arrow-left</v-icon>
            </v-btn>
            <v-card-title>
              <v-container>
                <h1>Cadastro</h1>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form>
                  <v-text-field v-model="cadastro.nome" color="blue" label="Nome completo"></v-text-field>
                  <v-text-field v-model="cadastro.CPF" color="blue" label="CPF" return-masked-value mask="###.###.###-##"></v-text-field>
                  <v-text-field :error-messages="statusEmail != null && !statusEmail ? 'Informe outro e-mail' : ''" color="blue" @input="goVerificaEmail()" v-model="cadastro.email" label="Email"></v-text-field>
                  <v-text-field @focus="goVerificaEmail()" v-model="cadastro.telefone" mask="(##)#####-####" return-masked-value color="blue" label="Telefone"></v-text-field>
                  <v-text-field @focus="goVerificaEmail()" :error="!confirmarSenhas()" v-model="cadastro.senha" color="blue" label="Senha" type="password"></v-text-field>
                  <v-text-field :error="!confirmarSenhas()" @input="[confirmarSenhas(), goVerificaEmail()]" v-model="senhaConfirma" :color="confirmarSenhas() ? 'blue' : 'red'" label="Confirmar senha" type="password"></v-text-field>
                  <v-dialog
                    color="blue"
                    ref="dialog"
                    v-model="modalDateCadastro"
                    :return-value.sync="cadastro.dataNascimento"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="cadastro.dataNascimento"
                        label="Data de Nascimento"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="blue" locale="pt-br" v-model="cadastro.dataNascimento" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="blue--text text--darken-1" @click="modalDateCadastro = false">Cancelar</v-btn>
                      <v-btn flat color="blue--text text--darken-1" @click="$refs.dialog.save(cadastro.dataNascimento)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-select v-model="cadastro.escolaridade" :items="escolaridades" item-text="Escolaridade" item-value="Codigo" label="Escolaridade" color="blue"></v-select>

                  <v-select v-model="tipoVinculoModel" :items="tipoVinculo" item-text="nome" item-value="id" label="Tipo de vínculo" color="blue"></v-select>
                  <v-select v-if="tipoVinculoModel == 4" v-model="parceiroModel" :items="parceirosList" item-text="RazaoSocial" item-value="IdParceiro" label="Parceiros"></v-select>

                  <!-- <input v-if="tipoVinculoModel == 4" accept="images/*" ref="image" type="file" @change="changeFile($event)"> -->


                  <input accept="images/*" ref="image" type="file" @change="changeFile($event)" style="display: none">
                  <v-text-field v-if="tipoVinculoModel == 4" v-model="nameFile" color="blue" @click="loadFile()" label="Arquivo" prepend-icon='mdi mdi-paperclip'></v-text-field>

                </v-form>
              </v-container>
              <v-alert v-if="requireds != null" type="error" :value="true">
                <div v-html="requireds"></div>
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-container>
                <v-btn :loading="cadastrando" :disabled="!confirmarSenhas()" class="blue darken-1 white--text" @click="goCadastro()" block large>
                  <v-icon left>mdi mdi-account-plus-outline</v-icon>
                  Cadastrar
                </v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <!--FORM DE RECUPERAÇÂO DE SENHA-->
      <v-layout v-show="recuperar != null" align-center justify-center class="animated fadeIn">
        <v-flex sm4>
          <v-card>
            <v-btn @click="recuperar = null" fab dark color="orange" class="backLogin">
              <v-icon dark>mdi mdi-arrow-left</v-icon>
            </v-btn>
            <v-card-title>
              <v-container>
                <h1>Recuperar senha</h1>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form>
                  <v-text-field v-model="CPFRecSenha" color="blue" mask="###.###.###-##" return-masked-value label="CPF"></v-text-field>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container>
                <v-btn :loading="loadRecSenha" @click="goRecuperar()" class="blue darken-1" block large dark>
                  <v-icon left>mdi mdi-key-variant</v-icon>
                  Recuperar Senha
                </v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-flex>
        <!-- Dialog para informar ao usuário as instruções para a recuperaao de senha -->
        <v-dialog width="500" v-model="dialog.show">
          <v-card>
            <v-card-title>
              <h1>Recuperação de senha</h1>
            </v-card-title>
            <v-card-text>
              A recuperação de senha foi efetuada com sucesso, acesse o e-mail <strong>{{ dialog.message }}</strong> e siga as instruções para a criação da nova senha.
            </v-card-text>
            <v-card-actions>
              <v-btn @click="dialog.show = !dialog.show" class="blue darken-1" dark>Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { validate as validateCPF } from 'gerador-validador-cpf'
import ToolbarSystem from '../components/ToolbarSystem'
import AlertbarSystem from '../components/AlertbarSystem'
export default {
  components:{
    ToolbarSystem,
    AlertbarSystem
  },
  data(){
    return{
      storage: localStorage,
      //Manipula a exibição da tela de recuperação de senha
      recuperar: null,
      //Manipula a exibição da tela de cadastro
      cadastroView: null,
      //Manipula a exibição da tela de recuperação
      CPFRecSenha: null,
      usuario:{
        login: "",
        senha: ""
      },
      //Manipulando load do botão logar
      logando: false,
      //Manipulando load do botão cadastro
      cadastrando: false,
      //Manipulando load do text-field de e-mail do cadastro
      statusEmail: null,
      loadEmail: null,
      //Manipulando bitão de recuperação de senhaConfirma
      loadRecSenha: false,
      //Exibindo Dialog de recuperação de senha
      dialog: {
        show: false,
        message: null
      },
      //Manipulando o modal de data do cadastro
      modalDateCadastro: null,
      tipoVinculoModel: 0,
      tipoVinculo:[
        {
          "id": 6,
          "nome": "Comunidade"
        },
        {
          "id": 4,
          "nome": "Parceiro"
        }
      ],
      parceirosList:[],
      parceiroModel: "",
      file: null,
      nameFile: null,
      cadastro:{
        nome: null,
        CPF: null,
        email: null,
        telefone: null,
        senha: null,
        dataNascimento: null,
        escolaridade: null,
        IdTipoCliente: null,
        IdPessoaJuridica: null
      },
      //Campos de cadastro requeridos
      requireds: null,
      escolaridades: null,
      senhaConfirma: null,
      AlertbarShow: null
    }
  },
  methods:{
    goLogin (){
      this.logando = true
      //Verificando a senha do usuário
      if((this.usuario.login != null || this.usuario.senha != null) && (this.usuario.login != "" || this.usuario.senha != "")){

        this.axios.post('login', {
          login: this.usuario.login,
          senha: this.usuario.senha
        }).then(res => {
          this.storage.setItem('token', 'Bearer ' + res.data.token)
          this.storage.setItem('idpessoafisica', res.data.IdPessoaFisica)
          location.href = "/aluno"
        }).catch(e => {
          this.AlertbarShow = {
            color: "red",
            show: true,
            time: 10000,
            text: e.response.data.message,
            bottom: false,
            right: true,
            multi: true
          }
        }).finally(() =>{
          this.logando = false
        })

      }else{
        //Pra que isso? Não sei, só sei que foi assim.
        this.AlertbarShow = {
          show: true,
          time: 10000,
          text: "Informe o usuário e senha",
          bottom: false,
          right: true,
          multi: true
        }
      }

    },
    async goCadastro (){

        await this.goVerificaEmail()
        this.cadastrando = true

        if(this.statusEmail){

          let formData = new FormData()
            formData.append('nome', this.cadastro.nome),
            formData.append('CPF', this.cadastro.CPF),
            formData.append('email', this.cadastro.email),
            formData.append('senha', this.cadastro.senha),
            formData.append('telefone', this.cadastro.telefone),
            formData.append('escolaridade', this.cadastro.escolaridade),
            formData.append('IdTipoCliente', this.tipoVinculoModel),
            formData.append('IdPessoaJuridica', this.parceiroModel),
            formData.append('Anexo', this.file == null ? "" : this.file[0]),
            formData.append('_method', "POST"),

          this.axios.post('/registro', formData).then(res => {

            this.requireds = null
            this.statusEmail = true
            this.AlertbarShow = {
              color: 'green',
              show: true,
              time: 10000,
              text: res.data,
              bottom: false,
              right: true,
              multi: true
            }
            setTimeout(function(){
              location.href = '/'
            }, 2000)
          }).catch(e =>{

            //Tratando Obj de erros para exibição.
            Object.entries(e.response.data.error).map(elem => {
              this.requireds = ""
              //Tratamento não recomendado, não faça isso sem a presença de um adulto.
              let texts = `<ul><li>${elem[1][0]}</li></ul>`
              this.requireds += texts
            })
          }).finally(() =>{
            this.cadastrando = false
          })
        }else{
          this.cadastrando = false
        }

    },

    cadastrarParceiro(){

            let formData = new FormData()
            formData.append('IdPessoaJuridica', this.IdpessoaJuridica),
            formData.append('Texto', this.textoDescricao),
            formData.append('AtoDeMesa', this.atoDeMesa),
            formData.append('VigenciaInicial', this.dataVigenciaInicial),
            formData.append('VigenciaFinal', this.dataVigenciaFinal),
            formData.append('Anexo', this.file == null ? "" : this.file[0]),
            formData.append('_method', "POST"),

            this.axios.post(`parceiro/`, formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).catch(e => {
                this.system.progress = false
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: e.response.data,
                    bottom: false,
                    right: true,
                    multi: true,
                    color: "error"
                }
            }).then(res => {
                this.system.progress = false
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true,
                    color: "success",
                }
                this.getParceiros()
                this.nullFields()
            })
            .finally(() => {
                this.novoParceiroView = false
            })
        },
    getEscolaridades () {
      this.axios.get('escolaridade').then( res => {
          this.escolaridades = res.data
      })
    },
    getParceiros(){
        this.axios.get(`parceiro/`).then(res => {
            this.parceirosList = res.data;
        }).catch(e => {
            this.system.AlertbarShow = {
                show: true,
                time: 10000,
                text: e.response.data,
                bottom: false,
                right: true,
                multi: true
            }
        }).finally(() => {
        })
    },
    formatDate(date){
        return this.$moment(date).format('L')
    },
    validaCPF(){
        if(this.usuario.login.length == 11){

          if(validateCPF(this.usuario.login)){
            return !true
          }else{
            return !false
          }

        }else if(this.usuario.login.length < 11){
          return true
        }
    },
    confirmarSenhas(){
      if(this.cadastro.senha != null && this.senhaConfirma != null){
        return this.cadastro.senha == this.senhaConfirma
      }else{
        if(this.cadastro.senha == null && this.senhaConfirma == null){
          return true
        }else{
          return false
        }
      }
    },
    async goVerificaEmail(){

      await this.axios.post('/verifica-email', {
        "verificar-email": this.cadastro.email
      }).then( () => {
        this.statusEmail = true
        this.AlertbarShow = {
          show: false
        }
      }).catch(e => {
        this.AlertbarShow = {
          color: "red",
          show: true,
          time: 10000,
          text: e.response.data.message,
          bottom: false,
          right: true,
          multi: true
        }
        this.statusEmail = false
      }).finally(() => {
          this.logando = false
      })
    },
    loadFile(){
        this.$refs.image.click ()
    },
    changeFile(e){
        this.file = e.target.files
        this.nameFile = this.file[0].name
    },
    goRecuperar (){
      this.loadRecSenha = true
      this.axios.post("recupera-senha",{
          cpf: this.CPFRecSenha
      }).then(res =>{
          this.dialog.show = true
          this.dialog.message = res.data
          this.recuperar = false
      }).catch(e => {
        this.AlertbarShow = {
          color: "red",
          show: true,
          time: 10000,
          text: e.response.data,
          bottom: false,
          right: true,
          multi: true
        }
      }).finally(() => {
          this.loadRecSenha = false
      })
    },
  },
  mounted(){
    this.getEscolaridades()
    this.getParceiros()
  }
}
</script>

<style scoped>
  .backLogin{
    position: absolute;
    top: -20px;
    left: -20px;
  }

  .imgAjust{
    margin: 15px 0 0 0;
  }
</style>
